import React, { useEffect, useState, useMemo, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  setClientBranchActions,
  setClientBranchDeleteActions,
  setGeoLoactionStateAction,
  setClientBranchSearchAction,
  setZoneActions,
  setRegionActions,
  getClientEditActions,
  getClientbranchEditView,
  setDetailView,
  getSideBarfilesActions,
  getClientBranchIds,
  SetTHeNavigateList,
  setTheBranchObject, ///--site---transfer
  setClientBranchSearchEmpty,
  Branch_EDIT_CLIENT_DETAILS, ///--for---client---details
  setTheMonthandYearFilters,
  setTheBranchNameAsListed, // to get th3e branch name
  setTheBranchListStateObject,
  setTheBranchListZONEObject,
  setTheBranchListObject,
  settheqrcodelisted,
  setCreateActive,
  SettheActiveTabsActionClientDetails,
  settheStore_filter_monthand_yeas,
  getthe_clientBranchDetails,
  setTablePositionPersist,
} from "../../../Redux/Slice";
import ReactTable from "../../AppComponent/Table";
import Delete from "../../AppComponent/Popup/Delete";
import "../../../StyleSheet/MainComponent/ClientBranches/ClientBranches.scss";
import ClientBranchCreate from "./ClientBranchCreate";
import Select from "react-select";
import { el, tr } from "date-fns/locale";
import clientimg from "../../../Assets/AppComponent/icons/Client/Vector.svg";
import Regionicons from "../../../Assets/AppComponent/icons/Locationicons/Layer_1 .png";
import { NavLink } from "react-router-dom";
import { Navigate, useNavigate } from "react-router-dom";
import _ from "lodash";
import DeleteImages from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-05.svg";
import EditImages from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-04 (1).svg";
import BackImage from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-20.svg";
import Qrcodeimg from "../../../Assets/AppComponent/Overall_icons/Scan Icon.svg";
import useDebouncedEffect from "use-debounced-effect";

const ClientBranches = () => {
  const stateDisplay = useSelector(
    (state) => state.SideBarActive.SidebarActive,
  );
  const UserObjectData = useSelector((state) => state.users.UserData);
  const TablePositionPersist = useSelector(
    (state) => state.PreviousPagePosition.TablePositionPersist,
  );

  const dispatch = useDispatch();
  const [dtpageindex, setdtPageindex] = useState(
    TablePositionPersist?.clientBranchPage?.page == undefined
      ? 1
      : TablePositionPersist.clientBranchPage.page,
  );
  const [search, setsearch] = useState(
    TablePositionPersist?.clientBranchPage?.search == "" ||
      TablePositionPersist?.clientBranchPage?.search == undefined
      ? ""
      : TablePositionPersist.clientBranchPage.search,
  );

  const [dtpagesize, setdtPagesize] = useState(20);
  const [pageSize, setPageSize] = useState(10);
  const [newpages, setNewpage] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [Datas, setDatas] = useState([]);
  const state = useSelector((state) => state);
  const [CreateBranch, setCreateBranch] = useState(false);
  const [BranchesEdits, setBranchesPopup] = useState(false);
  const [EditId, setEdit] = useState();
  const [DeleteID, setDeleteId] = useState();
  const [DeletePopup, setDeletePopup] = useState(false);
  const [State, setState] = useState([]);
  const [multiselect, setMuliselect] = useState([
    //  { value: "", label: "All" }
    // state.ClientBranchIDs.StateName,
    state.ClientBranchIDs.BranchList_State,
  ]);
  let [nameList, setOptions] = useState([]);
  const [nameList2, setOptions2] = useState([]);
  const [REgion, setRegion] = useState([]);
  const [multiselect1, setMuliselect1] = useState([
    // { value: "", label: "All" },
    // state.ClientBranchIDs.RegionName,
    state.ClientBranchIDs.BranchList_Region,
  ]);
  const [multiselect3, setMuliselect3] = useState([
    // { value: "", label: "All" },
    // state.ClientBranchIDs.ZoneName,
    state.ClientBranchIDs.BranchList_Zone,
  ]);
  const [nameList4, setOptions4] = useState([]);
  const [Zone, setZone] = useState([]);
  const [data, setData] = useState({
    // zone: state.ClientBranchIDs.ZoneName.value,
    // state: state.ClientBranchIDs.StateName.value,
    // region: state.ClientBranchIDs.RegionName.value,

    zone: state.ClientBranchIDs.BranchList_Zone.value,
    state: state.ClientBranchIDs.BranchList_State.value,
    region: state.ClientBranchIDs.BranchList_Region.value,
  });

  const [BranchSearch, setbranchSearch] = useState([]);
  const [Rendering, setRendering] = useState(true);
  const [details, setDetails] = useState(false);
  const [MakeCreate, setCreateBar] = useState(true);
  const [counts, setcounts] = useState(1);
  const [errorFilter, seterrorFilter] = useState({
    state: "",
    region: "",
    zone: "",
  });
  const [yearAndMonth, setYearMpnth] = useState();
  const date = new Date();
  console.log(date.getFullYear(), "date");
  const months =
    date.getMonth() < 10 ? `0${date.getMonth() + 1}` : date.getMonth();
  console.log(yearAndMonth, "yearAndMonth");
  //var yearAndMonth = `${date.getFullYear()}-${months}`;
  useEffect(() => {
    setYearMpnth(`${date.getFullYear()}-${months}`);
  }, []);

  const [Datamonth, setdata] = useState({
    month: months,
    year: date.getFullYear(),
  });

  ////---- end of the filters
  const [monthYearset, setMonthYear] = useState("");

  ///-----Month and yar based filter
  ////------month and year based filters-------------------------------
  const handleChange = (e) => {
    setMonthYear(e.target.value);
    const months = new Date(e.target.value);
    // months.getMonth()
    console.log(months.getMonth() + 1, "months", months.getFullYear());
    const selectedmonth =
      months.getMonth() < 10
        ? `0${months.getMonth() + 1}`
        : months.getMonth() + 1;
    setYearMpnth(`${months.getFullYear()}-${selectedmonth}`);
    console.log(e.target.value, "weurweydsfsd", selectedmonth);
    setdata({
      ...Datamonth,
      month: selectedmonth,
      year: months.getFullYear(),
    });
  };

  console.log(
    state.ClientBranchIDs.clientID,
    "piquepqweo",
    TablePositionPersist?.clientBranchPage,
    state.ClientBranch.ClientBranchess,
  );

  useEffect(() => {
    const payload = {
      search: search,
      page_size: 20,
      page: dtpageindex,
      client: state.ClientBranchIDs.clientID,
      state: data.state,
      region: data.region,
      zone: data.zone,
    };
    setcounts(1);

    //  if (
    //     state.ClientBranch.ClientBranchess.length == 0 ||
    //     TablePositionPersist?.clientBranchPage?.page != dtpageindex ||
    //     TablePositionPersist?.clientBranchPage?.state != data.state ||
    //     TablePositionPersist?.clientBranchPage?.region != data.region ||
    //     TablePositionPersist?.clientBranchPage?.client != state.ClientBranchIDs.clientID ||
    //     TablePositionPersist?.clientBranchPage?.zone != data.zone ||
    //     TablePositionPersist?.clientBranchPage?.search != search ||
    //     TablePositionPersist?.clientBranchPage?.to_call||

    //     TablePositionPersist?.clientBranchPage?.updated
    //     // apiTriggerCount == true
    //   ) {

    dispatch(setClientBranchActions(payload));

    dispatch(
      setTablePositionPersist({ data: payload, pageName: "clientBranchPage" }),
    );
    // if(TablePositionPersist?.clientBranchPage?.client != state.ClientBranchIDs.clientID){

    //   setdtPageindex(1)
    // }

    // }
    currentRef.current.scrollTop = sessionStorage.getItem(
      "clientBranchPageTableScrollPosition",
    );
  }, [dtpagesize, Datamonth, dtpageindex, data, search]);

  const initialStateSearch = {
    stateSearch: "",
    regionSearch: "",
    zoneSearch: "",
  };
  const [SearchedVal, setSearched] = useState(initialStateSearch);

  const initialDebouanceSearch = {
    stateSearch: "",
    regionSearch: "",
    zoneSearch: "",
  };
  const [SearchDebounance, setSearchDebounance] = useState(
    initialDebouanceSearch,
  );

  useDebouncedEffect(
    () => {
      if (setSearchDebounance) {
        setSearched({
          ...SearchedVal,
          stateSearch: SearchDebounance.stateSearch,
          regionSearch: SearchDebounance.regionSearch,
          zoneSearch: SearchDebounance.zoneSearch,
        });
      }
    },
    500,
    [SearchDebounance],
  );

  ///-----State----Input Changes
  const handleInputChange = (Val) => {
    console.log(Val, "Values");
    setSearchDebounance({
      ...SearchDebounance,
      stateSearch: Val,
    });
  };
  //---Zone----
  const handleInputZone = (Val) => {
    setSearchDebounance({
      ...SearchDebounance,
      zoneSearch: Val,
    });
  };
  ///----Regions----
  const handleInputRegion = (Val) => {
    setSearchDebounance({
      ...SearchDebounance,
      regionSearch: Val,
    });
  };
  const debouncedSearch = useMemo(
    () =>
      _.debounce((e) => {
        setsearch(e);
      }, 500),
    [],
  );

  // -----Search------------------------
  function tochange(e) {
    // console.log("ee", e);
    setdtPageindex(1);
    debouncedSearch(e);
  }

  React.useEffect(() => {
    return () => {
      debouncedSearch.cancel();
    };
  }, [debouncedSearch]);

  const pagesize = (arg) => {
    setdtPagesize(arg);
  };

  const pageindex = (arg) => {
    ///   console.log(arg, "args");
    setdtPageindex(arg);
  };
  //---Create
  const CreateBranchFunction = () => {
    // window.location.href = "/clientcreate";
    console.log("dasdasd siydo ");

    setBranchesPopup(true);
    setEdit(undefined);
    dispatch(getClientbranchEditView(""));

    //dispatch(setDetailView(false))
  };
  //--Edit---
  const ClientEditFunctions = (id) => {
    // setBranchesPopup(!BranchesEdits);
    setBranchesPopup(true);

    setEdit(id);
    dispatch(getClientEditActions(true));
    dispatch(getClientbranchEditView(id));
    dispatch(setDetailView(false));
    // window.location.href = "/clientcreate"
  };
  const Navigate = useNavigate();
  ////---View
  const ViewFunctions = (id) => {
    console.log(id, "sdgsdgsgts");
    dispatch(setCreateActive(1));
    const currentMonth = new Date().getMonth() + 1; // 1–12
    const currentYear = new Date().getFullYear(); // e.g., 2025

    dispatch(
      settheStore_filter_monthand_yeas({
        month: currentMonth,
        year: currentYear,
      }),
    );

    /// for the Inner views

    const newEntry_approve = {
      search: "",
      page_size: 20,
      // page: state.NeededdatasListed.PageIndex,
      page: 1,
    };
    const result_approved_emp = {
      ...TablePositionPersist.Appprove_empDatas,
      ...newEntry_approve,
    };
    dispatch(
      setTablePositionPersist({
        data: result_approved_emp,
        pageName: "Appprove_empDatas",
      }),
    );

    const newEntry_shift = {
      search: "",
      page_size: 20,
      // page: state.NeededdatasListed.PageIndex,
      page: 1,
    };
    const result_Shift_emp = {
      ...TablePositionPersist.Shift_empDatas,
      ...newEntry_shift,
    };
    dispatch(
      setTablePositionPersist({
        data: result_Shift_emp,
        pageName: "Shift_empDatas",
      }),
    );

    const newEntry_leave_status = {
      search: "",
      page_size: 20,
      // page: state.NeededdatasListed.PageIndex,
      page: 1,
    };
    const result_Leave_list_emp = {
      ...TablePositionPersist.Leave_empDatas,
      ...newEntry_leave_status,
    };
    dispatch(
      setTablePositionPersist({
        data: result_Leave_list_emp,
        pageName: "Leave_empDatas",
      }),
    );

    const Shift_upload_status = {
      search: "",
      page_size: 20,
      // page: state.NeededdatasListed.PageIndex,
      page: 1,
    };
    const result_Shiftupload_list_emp = {
      ...TablePositionPersist.ShiftUpload_empDatas,
      ...Shift_upload_status,
    };
    dispatch(
      setTablePositionPersist({
        data: result_Shiftupload_list_emp,
        pageName: "ShiftUpload_empDatas",
      }),
    );

    const Supervisour_status = {
      search: "",
      page_size: 20,
      // page: state.NeededdatasListed.PageIndex,
      page: 1,
    };
    const result_Supervisourlist = {
      ...TablePositionPersist.Supervisor_empDatas,
      ...Supervisour_status,
    };
    dispatch(
      setTablePositionPersist({
        data: result_Supervisourlist,
        pageName: "Supervisor_empDatas",
      }),
    );

    dispatch(SettheActiveTabsActionClientDetails(1));
    dispatch(
      setTheMonthandYearFilters({
        //  month: Datamonth.month,
        // year: Datamonth.year,
      }),
    );
    dispatch(getClientbranchEditView(id.id));
    ///---onboard---employeee----list
    dispatch(setTheBranchObject({ value: id.id, label: id.client_name })); ///--for---site---transfer

    //setEdit(row.row.original.id);
    dispatch(getClientEditActions(true));
    dispatch(setDetailView(true));
    setDetails(true);
    // window.location.href = "/clientDetails";
    // Navigate("/clientDetails");
    dispatch(getClientBranchIds(id.client_id.id));
    console.log("isdasdasdashds", id.client_id.id, id);
    if (
      id.client_id.id == state.ClientBranchIDs.ClientBranchID &&
      id.id == state.ClientBranchIDs.clientBranchEditView
    ) {
      //console.log(id.client_id.id, "clientBranch IDS");
      Navigate("/clientDetails");
    }
    // dispatch(SetTHeNavigateList("/clientbranch"));
    dispatch(SetTHeNavigateList(["/ClientDetails"]));
    dispatch(getSideBarfilesActions("Client"));
  };
  const [View, setViews] = useState(true);
  const truncateText = (text, maxLength) => {
    if (text.length <= maxLength) {
      return text;
    }
    return text.substring(0, maxLength) + "...";
  };

  const formatedDateListwithouttime = (dateString) => {
    const date = new Date(dateString);

    // Options for date formatting (only date)
    const dateOptions = {
      month: "short", // e.g., Dec
      day: "2-digit", // e.g., 22
      year: "numeric", // e.g., 2024
    };

    // Options for time formatting (only time)
    const timeOptions = {
      hour: "2-digit", // e.g., 02
      minute: "2-digit", // e.g., 16
      hour12: true, // e.g., AM/PM format
    };

    // Format the date and time separately
    const formattedDate = date.toLocaleDateString("en-US", dateOptions);
    const formattedTime = date.toLocaleTimeString("en-US", timeOptions);

    // Combine the formatted date and time
    return `${formattedDate}`;
  };

  const HandletheQrCode = (e) => {
    const payload = {
      EditID: e,
    };
    dispatch(settheqrcodelisted(payload));
  };

  const truncate = (text, limit = 10) => {
    if (!text) return "---";
    return text.length > limit ? text.slice(0, limit) + "..." : text;
  };

  const columns = [
    {
      Header: "Client Branch",
      accessor: "",
      Cell: (row) => {
        const [showTooltip, setShowTooltip] = useState(false);

        return (
          <>
            {row.row.original.client_name != undefined &&
            row.row.original.client_name != null &&
            row.row.original.client_name != "" ? (
              <div
                className="UserName"
                onMouseEnter={() => setShowTooltip(true)}
                onMouseLeave={() => setShowTooltip(false)}
                style={{ position: "relative" }}
              >
                <span>
                  {row.row.original.client_name ? (
                    truncateText(row.row.original.client_name, 20)
                  ) : (
                    <>{row.row.original.client_name}</>
                  )}
                </span>

                {showTooltip && (
                  <div className="custom-tooltip-branch">
                    {row.row.original.client_name}
                  </div>
                )}
              </div>
            ) : (
              <span>{"--"}</span>
            )}
          </>
        );
      },
    },
    {
      Header: "Branch Code",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            {row.row.original.branch_code != null ? (
              <span>{row.row.original.branch_code}</span>
            ) : (
              <span>---</span>
            )}
          </>
        );
      },
    },
    {
      Header: "State",
      accessor: "",
      Cell: ({ row }) => {
        const state = row.original.state_id?.state_name;
        return <span>{truncate(state, 12)}</span>; // limit = 12 chars
      },
    },
    {
      Header: "Region",
      accessor: "",
      Cell: ({ row }) => {
        const region = row.original.region_id?.region_name;
        return <span>{truncate(region, 12)}</span>;
      },
    },

    {
      Header: "Zone",
      accessor: "",
      Cell: ({ row }) => {
        const zone = row.original.zone_id?.zone_name;
        return <span>{truncate(zone, 12)}</span>;
      },
    },

    {
      Header: "Created Date",
      accessor: "",
      Cell: (row) => {
        const dateString = row.row.original.created_at;
        const dateObject = new Date(dateString);
        const hours = dateObject.getHours();
        const minutes = dateObject.getMinutes();
        const seconds = dateObject.getSeconds();
        const amOrPm = hours >= 12 ? "PM" : "AM";
        const twelveHourFormat = hours % 12 || 12;
        const formattedTime = `${twelveHourFormat}:${minutes} ${amOrPm}`;
        return (
          <>
            <div className="CreatedDatelisted">
              {/* {`${row.row.original.created_at.slice(0, 10) }`} */}
              {row.row.original.created_at
                ? formatedDateListwithouttime(row.row.original.created_at)
                : ""}
            </div>
          </>
        );
      },
    },

    {
      Header: "Actions",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            <div
              class="actions"
              style={{
                display: "flex",
                justifyContent: "flex-start",
                gap: "5px",
              }}
            >
              <button
                className=" btn Status"
                component="span"
                onClick={(e) => {
                  e.stopPropagation();
                  dispatch(
                    setTheMonthandYearFilters({
                      month: Datamonth.month,
                      year: Datamonth.year,
                    }),
                  );
                  dispatch(getthe_clientBranchDetails(row.row.original));
                  dispatch(Branch_EDIT_CLIENT_DETAILS(1));
                  ClientEditFunctions(row.row.original.id);
                }}
              >
                <span className="OuterActionSpan">
                  <span className="EditImages">
                    <img src={EditImages} />
                  </span>

                  <span className="ActionsList"> Edit </span>
                </span>
              </button>
              {state.ClientBranchIDs.SUBROLE == 3 && (
                <button
                  type="button"
                  class="btn Status"
                  onClick={(e) => {
                    e.stopPropagation();
                    setDeleteId(row.row.original.id);
                    setDeletePopup(true);
                  }}
                >
                  <span className="OuterActionSpan">
                    <span className="EditImages">
                      <img src={DeleteImages} />
                    </span>
                    <span className="ActionsList"> Delete </span>
                  </span>
                </button>
              )}

              {/* <button
                type="button"
                class="btn Status"
                onClick={(e) => {
                  e.stopPropagation();
                  HandletheQrCode(row.row.original.id)
                }}
              >
                <span className="OuterActionSpan">
                  <span className="EditImages">
                    <img src={Qrcodeimg} />
                  </span>
                  <span className="ActionsList"> QR code </span>
                </span>
              </button> */}
            </div>
          </>
        );
      },
    },
  ];
  const HandleSubmits = () => {
    setsearch("");
    setdtPageindex(1);
    const payloads_tocall = {
      search: "",
      page_size: 20,
      page: 1,
      client: state.ClientBranchIDs.clientID,
    };
    dispatch(
      setTablePositionPersist({
        data: payloads_tocall,
        pageName: "clientBranchPage",
      }),
    );

    if (DeleteID != undefined) {
      const payload = {
        DeleteID: DeleteID,
        currentPage: dtpageindex,
        client: state.ClientBranchIDs.clientID,
        //  month: Datamonth.month,
        // year: Datamonth.year,
      };
      dispatch(setClientBranchDeleteActions(payload, setDeletePopup(false)));
    }
  };

  ///--------------State-----------------
  useEffect(() => {
    const payloads = {
      search: SearchedVal.stateSearch,
      page_size: "",
      page: 1,
    };
    dispatch(setGeoLoactionStateAction(payloads));
    setState(state.GeoState.State);
  }, [SearchedVal.stateSearch]);
  //--------------_Zone---------------
  useEffect(() => {
    const payloads = {
      search: SearchedVal.zoneSearch,
      page_size: 20,
      page: 1,
      counts: 1,
      region_id: data.region,
    };
    dispatch(setZoneActions(payloads));
    setZone(state.ZonePart.Zone);
  }, [data.region, SearchedVal.zoneSearch]);

  //-----Region---------
  useEffect(() => {
    const payloads = {
      search: SearchedVal.regionSearch,
      page_size: 20,
      page: 1,
      counts: 1, //-----only we ----get----the----selected regions , the--id only
      state: data.state,
    };
    dispatch(setRegionActions(payloads));
    //console.log(State.regioncall.RegionDat, "states", State.regioncall.Total_Count);
    setRegion(state.regioncall.RegionDat);
  }, [data.state, SearchedVal.regionSearch]);

  const handleSelectChange = (selectedVal) => {
    setdtPageindex(1);
    if (selectedVal != null) {
      setMuliselect1({ value: "search", label: "Search" });
      setMuliselect3({ value: "search", label: "Search" });
      dispatch(setTheBranchListStateObject(selectedVal));
      dispatch(setTheBranchListObject({ value: "", label: "Search" }));

      dispatch(setTheBranchListZONEObject({ value: "", label: "Search" }));

      setMuliselect(selectedVal);
      setdtPageindex(1);
      console.log(selectedVal, "asfad");
      setData({
        ...data,
        state: selectedVal.value,
        region: "",
        zone: "",
      });
      setcounts(2);
    }
    if (selectedVal == null) {
      setMuliselect1({ value: "search", label: "Search" });
      setMuliselect3({ value: "search", label: "Search" });
      setMuliselect({ value: "", label: "ALL" });

      dispatch(setTheBranchListStateObject({ value: "", label: "Search" }));
      dispatch(setTheBranchListObject({ value: "", label: "Search" }));

      dispatch(setTheBranchListZONEObject({ value: "", label: "Search" }));

      setData({
        ...data,
        state: "",
        region: "",
        zone: "",
      });
    }
  };
  //
  // useEffect(() => {
  // console.log(state.ClientBranch.ClientBranchess, "statesxasfsd");
  // if (data.state == null || data.state == undefined) {
  // console.log("yfusdyufyu");
  // }
  // }, [data.state]);
  //

  useEffect(() => {
    const Datas = [];

    setState(state.GeoState.State.state_name);
    if (state.GeoState.State != undefined) {
      let objectArray = [];
      objectArray.push({ value: "", label: "ALL" });

      state.GeoState.State.forEach((element) => {
        objectArray.push({
          value: element.id,
          label: element.state_name.toUpperCase(),
        });
      });

      setOptions(objectArray);
    }
  }, [state.GeoState.State, SearchedVal.stateSearch]);
  ///  ///----------------------REgion-----------
  useEffect(() => {
    const Datas = [];

    setRegion(state.regioncall.RegionDat);
    if (state.regioncall.RegionDat != undefined) {
      let objectArray = [];
      state.regioncall.RegionDat.forEach((element) => {
        objectArray.push({
          value: element.id,
          label: element.region_name.toUpperCase(),
        });
      });

      setOptions2(objectArray);
    }
  }, [state.regioncall.RegionDat, SearchedVal.regionSearch]);
  //----Region----------------
  const handelRegionSlect = (selectedVal) => {
    setdtPageindex(1);
    setMuliselect3({
      value: "",
      label: "Search",
    });
    if (selectedVal != null) {
      setMuliselect1(selectedVal);
      setData({
        ...data,
        region: selectedVal.value,
        zone: "",
      });
      setcounts(2);

      dispatch(setTheBranchListObject(selectedVal));

      dispatch(setTheBranchListZONEObject({ value: "", label: "Search" }));
    }

    if (selectedVal == null) {
      setMuliselect1({ value: "", label: "ALL" });
      setMuliselect3({ value: "", label: "ALL" });

      dispatch(setTheBranchListObject({ value: "", label: "Search" }));

      dispatch(setTheBranchListZONEObject({ value: "", label: "Search" }));

      setData({
        ...data,
        region: "",
        zone: "",
      });
    }
  };
  //----------------Zone
  const handleZone = (selectedVal) => {
    //console.log(selectedVal ,"selected Values");
    setdtPageindex(1);
    if (selectedVal != null) {
      setMuliselect3(selectedVal);
      setData({
        ...data,
        zone: selectedVal.value,
      });
      setcounts(2);
      dispatch(setTheBranchListZONEObject(selectedVal));
    }
    if (selectedVal == null && data.region == null && data.state == null) {
      setData({
        ...data,
        zone: "",
      });
    }

    if (selectedVal == null) {
      setMuliselect3({ value: "", label: "Search" });
      dispatch(setTheBranchListZONEObject({ value: "", label: "Search" }));

      setData({
        ...data,
        zone: "",
      });
      setcounts(2);
    }
  };
  ///-------------Zone--------------
  useEffect(() => {
    const Datas = [];

    setZone(state.ZonePart.Zone);
    if (state.ZonePart.Zone != undefined) {
      let objectArray = [];
      state.ZonePart.Zone.forEach((element) => {
        objectArray.push({
          value: element.id,
          label: element.zone_name.toUpperCase(),
        });
      });
      setOptions4(objectArray);
    }
  }, [state.ZonePart.Zone, SearchedVal.zoneSearch]);

  const handleNext = (next) => {
    console.log(next, "woiquenext");

    setdtPageindex(next + 1);
  };

  const GotoEnteredPage = (gotopage) => {
    setdtPageindex(gotopage);
  };

  const handlePrevious = (previous) => {
    if (previous != 0) {
      setdtPageindex(previous);
    }
  };

  const currentRef = useRef();
  const scrollPosition = (e) => {
    const val = currentRef.current.scrollTop;
    sessionStorage.setItem("clientBranchPageTableScrollPosition", val);
  };

  return (
    <>
      <div
        onScroll={scrollPosition}
        ref={currentRef}
        className={stateDisplay ? "outterContent" : "inner-Content"}
      >
        <div
          className="Header-Details ClientBranch row"
          style={{ padding: "14px 28px" }}
        >
          <div
            class="col-sm-7 auto"
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              justifyContent: "flex-start",
            }}
          >
            <h3>Client Branch</h3>
          </div>

          <div className="createticketing col-sm-5">
            <button
              className="Createbutton"
              onClick={(e) => {
                CreateBranchFunction();
              }}
            >
              {" "}
              Create{" "}
            </button>
          </div>
        </div>

        <div
          className="row Filters ButtonPrevious"
          style={{
            padding: "0px 28px",
            margin: "0px",
            position: "relative",
            zIndex: "30",

            marginLeft: "0px",
            marginRight: "0px",
            top: "-12px",
          }}
        >
          <div className="col">
            <button
              className="btn BackImga"
              onClick={(e) => {
                Navigate("/client");
              }}
            >
              <img className="PreviousPages" src={BackImage} />
              {/* <span className="BackImageSpan">              <img src={backImage}/>
    </span> */}
              <span></span>
            </button>
          </div>
        </div>
        <div
          className="row Filters"
          style={{
            padding: "15px 28px",
            margin: "0px",
            position: "relative",
            zIndex: "30",

            marginLeft: "0px",
            marginRight: "0px",
            top: "-15px",
          }}
        >
          <div className="col-sm-2">
            <label for="validationCustom01" class="form-label">
              State
            </label>
            <Select
              className="Selects"
              styles={{ position: "relative", top: "60px" }}
              // options={options}
              // onChange={handleChange}
              onSelect={(e) => {
                setMuliselect(e);
              }}
              onChange={(e) => {
                setdtPageindex(1);
                handleSelectChange(e);
              }}
              // isClearable={multiselect.length > 0 ? false : true}
              options={nameList}
              onInputChange={handleInputChange}
              onremoved={(e) => {
                setMuliselect(e);
                console.log(e, "jjk9090");
              }}
              labelledBy="Select"
              value={multiselect}
            />
          </div>

          <div className="col-sm-2">
            <label for="validationCustom01" class="form-label">
              Region
            </label>
            <Select
              className="Selects"
              styles={{ position: "relative", top: "60px" }}
              // options={options}
              // onChange={handleChange}
              onSelect={(e) => setMuliselect1(e)}
              onChange={(e) => {
                seterrorFilter({ ...errorFilter, region: "" });
                setdtPageindex(1);

                handelRegionSlect(e);
              }}
              options={nameList2}
              labelledBy="Select"
              isClearable={
                multiselect1
                  ? Array.isArray(multiselect1)
                    ? multiselect1.some(
                        (item) => item.label === "ALL" || item.label === "All",
                      )
                      ? false
                      : true
                    : multiselect1.label === "ALL" ||
                        multiselect1.label === "All"
                      ? false
                      : true
                  : true
              }
              value={multiselect1}
              onremoved={(e) => {
                setMuliselect1(e);
              }}
              // placeholder={
              //   data.state == ""
              //     ? "without selected state you can't select Region"
              //     : "search"
              // }
              onInputChange={handleInputRegion}
            />
            <p>{errorFilter.region}</p>
          </div>

          <div className="col-sm-2">
            <label for="validationCustom01" class="form-label">
              Zone
            </label>
            <Select
              className="Selects"
              styles={{ position: "relative", top: "60px" }}
              // options={options}
              // onChange={handleChange}
              onSelect={(e) => setMuliselect3(e)}
              onChange={(e) => {
                setdtPageindex(1);
                handleZone(e);
              }}
              options={nameList4}
              isClearable={
                multiselect3
                  ? Array.isArray(multiselect3)
                    ? multiselect3.some(
                        (item) => item.label === "ALL" || item.label === "All",
                      )
                      ? false
                      : true
                    : multiselect3.label === "ALL" ||
                        multiselect3.label === "All"
                      ? false
                      : true
                  : true
              }
              value={multiselect3}
              onremoved={(e) => {
                setMuliselect3(e);
              }}
              // placeholder={
              //   data.state == ""
              //     ? "without selected state you can't select Zone"
              //     : data.region == ""
              //     ? "without selected Region you can't select Zone"
              //     : "Search"
              // }
              labelledBy="Select"
              onInputChange={handleInputZone}
            />
          </div>
          {/* <div className="col ">
            <label for="validationCustom01" class="form-label">
              Wbs Element
            </label>
            <Select
              className="Selects"
              styles={{ position: "relative", top: "60px" }}
              // options={options}
              // onChange={handleChange}
              // onSelect={(e) => {
              //   setMuliselect(e);
              // }}
              // onChange={(e) => {
              //   handleSelectChange(e);
              // }}
              // isClearable={true}
              // options={nameList}
              // onInputChange={handleInputChange}
              // onremoved={(e) => {
              //   setMuliselect(e);
              //   console.log(e, "jjk9090");
              // }}
              // labelledBy="Select"
            />
          </div> */}
        </div>

        {Datas != undefined ? (
          <div style={{ padding: "  0px 40px", marginTop: "-10px " }}>
            <ReactTable
              //  data={state.ClientBranch.ClientBranchess}
              data={
                // BranchSearch == undefined ||
                // BranchSearch == [] ||
                // BranchSearch == ""
                // counts == 1
                //   ? //Datas
                //     state.ClientBranch.ClientBranchess
                //   : state.BranchSearchpart.BranchSearch
                //BranchSearch
                state.ClientBranch.ClientBranchess
              }
              columns={columns}
              currentPage={currentPage}
              totalItems={
                // counts == 1
                //   ? state.ClientBranch.Total_Count
                //   : state.BranchSearchpart.Total_count
                state.ClientBranch.Total_Count
              }
              pagesize={pagesize}
              dtpagesize={dtpagesize}
              dtpageindex={dtpageindex}
              pageindex={pageindex}
              datacount={
                // counts == 1
                //   ? state.ClientBranch.Total_Count
                //   : state.BranchSearchpart.Total_count
                state.ClientBranch.Total_Count
              }
              // OnhandleLastpgae={HandleLastPage}
              onChange={tochange}
              MakeCreate={MakeCreate}
              Oncreate={(e) => {
                CreateBranchFunction();
              }}
              // //---Month based filter
              // MonthFilter={true}
              // yearAndMonth={yearAndMonth}
              // handleChange={handleChange}
              // Filter={true}
              // Superviorsfilter={false}
              // OldEmployeFilters={false}
              // nostatusFilter={true}
              // ///----

              ViewParts={(e) => {
                dispatch(getthe_clientBranchDetails(e));
                dispatch(setTheBranchNameAsListed(e.client_name));
                ViewFunctions(e);
              }}
              Filter={true}
              NoFilter={true}
              onPrevious={handlePrevious}
              onNextpage={handleNext}
              GotoEnteredPage={GotoEnteredPage}
              searchVal={
                TablePositionPersist?.clientBranchPage?.search == "" ||
                TablePositionPersist?.clientBranchPage?.search == undefined
                  ? ""
                  : TablePositionPersist.clientBranchPage.search
              }
              search_key={true}
            />
          </div>
        ) : null}
      </div>

      {
        // EditId != undefined &&
        BranchesEdits == true ? (
          <ClientBranchCreate
            show={state.ClientBranchIDs.ClientEditFunctions}
            setShow={setBranchesPopup}
            currentPage={dtpageindex}
            EditId={EditId}
            details={details}
            setDetails={setDetails}
            // Datamonth={{ month: Datamonth.month, year: Datamonth.year }}
          />
        ) : null
      }

      {DeletePopup ? (
        <Delete
          show={DeletePopup}
          setShow={setDeletePopup}
          onSubmit={HandleSubmits}
          Content={"Do you want to delete the Client Branch"}
        />
      ) : null}

      <>
        {/* <Tooltip
          id="Name-ToolTips"
          className="ReactTooltip"
          // noArrow
          BottomRight
          style={{ zIndex: 9999 }} // Adjust the value as needed
        /> */}
        {/* <Tooltip id="Name-ToolTips" zIndex={999} /> */}
      </>
    </>
  );
};

export default ClientBranches;
